import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (err, fallback) => {
    if (err.response?.data) throw err.response.data;
    throw err.message || fallback;
};

// GET the vendor-wise outstanding summary grid, CC-scoped server-side by UID/Roleid
export const getVendorOutStandingReportData = async ({ VendorType, UID, Roleid }) => {
    try {
        const res = await axios.get(`${base}/Reports/VendorOutStandingReportData`, { params: { VendorType, UID, Roleid } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch vendor outstanding report'); }
};

// GET the per-invoice breakdown behind one summary row
export const getVendorOutStandingReportInnerData = async ({ Vendorcode }) => {
    try {
        const res = await axios.get(`${base}/Reports/VendorOutStandingReportInnerData`, { params: { Vendorcode } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch invoice detail'); }
};
